import React from "react"
import SocialLinks from "../constants/socialLinks"
const Footer = () => {
  return <footer className="footer">
    <div>
      <SocialLinks styleClass="footer-links" />
      <h4>copyright<sup>&copy;</sup> {new Date().getFullYear()}</h4>
      <span>mattluck.dev</span> all rights reserved
    </div>
  </footer>
}

export default Footer
